import { msg } from '@lingui/core/macro';
import { defineFilters } from '@/shared/filters/define-filters';
export const productFilters = defineFilters([
  {
    key: 'searchString',
    type: 'search',
    label: msg`Todos`,
    placeholder: msg`Buscar produtos de conta`,
  },
  { key: 'name', type: 'text', label: msg`Nome do produto` },
  { key: 'orderBy', type: 'text', label: msg`Proprietário` },
  {
    key: 'initialDate',
    to: 'finalDate',
    type: 'dateRange',
    label: msg`Data da ocorrência`,
    fromLabel: msg`De`,
    toLabel: msg`Até`,
    sendTo: false,
  },
]);
